export default __webpack_public_path__ + "static/media/product-13 (2).27eb69f9.jpg";